import { css } from 'styled-components';
import { Device, from } from './media';
export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export const headerOverlap = css `
  margin-top: -78px !important;

  @media ${from(Device.Tablet)} {
    margin-top: -174px !important;
  }
`;
export const headerOverlapPadding = css `
  padding-top: 78px !important;

  @media ${from(Device.Tablet)} {
    padding-top: 174px !important;
  }
`;
